<template>
    <brick-base class="brick-circle" @click="$emit('click', $event)" @mouseup="$emit('mouseup', $event)">
        <slot />
    </brick-base>
</template>

<script>
    import BrickBase from './BrickBase.vue';

    export default {
        name: 'brick-circle-base',
        components: {
            BrickBase
        }
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/brick-circle-base.scss";
</style>